export enum FeaturesConfig {
  ManageUsers = 28,
  ViewProfile = 40,
}
